import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { FormBuilder, FormGroup } from '@angular/forms';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { DatePipe } from '@angular/common';

import { SharedFunctions } from '../../../../../../src/app/shared/shared.functions';

import { MovimientoService } from '../../../../../../src/app/shared/services';
import { SearchMovimientoRequest, GridPageSettings, DialogDetalleMovimientosCuentasDeudorasRequestDto, EnviarDetalleDeudaRequestDto } from '../../../../../../src/app/shared/model';
import { ExportMediaTypeConstants } from '../../../../shared/model';

@Component({
  selector: 'app-dialogDetalleMovimientosCuentasDeudoras',
  templateUrl: 'dialogDetalleMovimientosCuentasDeudoras.component.html'
})

export class DialogDetalleMovimientosCuentasDeudorasComponent implements OnInit {

  isSearching: boolean = false;
  isExporting: boolean = false;
  isContactosSearching: boolean = false;
  isContactosExporting: boolean = false;

  @ViewChild('grid')
  public grid: GridComponent;
  public query: Query;

  searchForm: FormGroup;

  verSoloVencidos: boolean = false;

  contactosList: any[];

  public data: DataManager;
  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    private dialogRef: MatDialogRef<DialogDetalleMovimientosCuentasDeudorasComponent>,
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private movimientoService: MovimientoService,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public input: DialogDetalleMovimientosCuentasDeudorasRequestDto) {

  }

  ngOnInit() {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    if (this.input != null && !this.input.VerSoloContactos) {
      this.buildForm();

      this.setQueryParams();

      this.data = new DataManager({
        url: this.movimientoService.getSearchUrl(),
        adaptor: new WebApiAdaptor(),
        headers: [this.movimientoService.getAuthorizationHeader(),this.movimientoService.getTenantHeader()]
      });
    }

    this.getContactos();
  }

  buildForm() {
    this.searchForm = this.formBuilder.group({
      'FechaMovimientoDesde': [null],
      'FechaMovimientoHasta': [null],
      'FechaVencimientoDesde': [null],
      'FechaVencimientoHasta': [null],

      'NroDocumento': [null],
      'MailContacto': [null],
      'MovilContacto': [null],
      'Usuario': [null],
      'ComunidadId': [null],
      'ConsorcioId': [null],
      'UnidadFuncionalId': [null],
      'Proveedor': [null],

      'CuentaImputadaId': [null],

      'PedidoId': [null],
      'Contrato': [null],

      'Detalle': [null],
      'TipoMovimientoId': [null],
      'MonedaId': [null],
      'Estados': [null],
      'MedioPagoId': [null],
      'Signo': [null],
      'VerSoloDeudasPendientes': [null],
      'VerSoloActivos': [true],
      'gridPage': [1]
    });

    if (this.input != null && this.input != null && this.input.ReportFilter != null)
      this.searchForm.patchValue(this.input.ReportFilter);
  }

  onSearch() {
    this.setQueryParams();
    this.grid.refresh();
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "MedioPagoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MedioPagoId;
    else
      this.query.addParams("MedioPagoId",this.searchForm.value.MedioPagoId);

    index = this.query.params.findIndex(obj => obj.key === "FechaMovimientoDesde");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaMovimientoDesde, "yyyy-MM-dd");
    else
      this.query.addParams("FechaMovimientoDesde", this.datePipe.transform(this.searchForm.value.FechaMovimientoDesde, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaMovimientoHasta");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaMovimientoHasta, "yyyy-MM-dd");
    else
      this.query.addParams("FechaMovimientoHasta", this.datePipe.transform(this.searchForm.value.FechaMovimientoHasta, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaVencimientoDesde");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaVencimientoDesde, "yyyy-MM-dd");
    else
      this.query.addParams("FechaVencimientoDesde", this.datePipe.transform(this.searchForm.value.FechaVencimientoDesde, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaVencimientoHasta");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaVencimientoHasta, "yyyy-MM-dd");
    else
      this.query.addParams("FechaVencimientoHasta", this.datePipe.transform(this.searchForm.value.FechaVencimientoHasta, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "Estados");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Estados;
    else
      this.query.addParams("Estados", this.searchForm.value.Estados);

    index = this.query.params.findIndex(obj => obj.key === "CuentaImputadaId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.CuentaImputadaId;
    else
      this.query.addParams("CuentaImputadaId",this.searchForm.value.CuentaImputadaId);

    index = this.query.params.findIndex(obj => obj.key === "PedidoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.PedidoId;
    else
      this.query.addParams("PedidoId",this.searchForm.value.PedidoId);

    index = this.query.params.findIndex(obj => obj.key === "Contrato");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Contrato;
    else
      this.query.addParams("Contrato",this.searchForm.value.Contrato);

    index = this.query.params.findIndex(obj => obj.key === "MonedaId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MonedaId;
    else
      this.query.addParams("MonedaId",this.searchForm.value.MonedaId);

    index = this.query.params.findIndex(obj => obj.key === "Detalle");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Detalle;
    else
      this.query.addParams("Detalle",this.searchForm.value.Detalle);

    index = this.query.params.findIndex(obj => obj.key === "TipoMovimientoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.TipoMovimientoId;
    else
      this.query.addParams("TipoMovimientoId",this.searchForm.value.TipoMovimientoId);

    index = this.query.params.findIndex(obj => obj.key === "ProveedorId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Proveedor?.Id;
    else
      this.query.addParams("ProveedorId",this.searchForm.value.Proveedor?.Id);

    index = this.query.params.findIndex(obj => obj.key === "ConsorcioId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ConsorcioId;
    else
      this.query.addParams("ConsorcioId",this.searchForm.value.ConsorcioId);

    index = this.query.params.findIndex(obj => obj.key === "ComunidadId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadId;
    else
      this.query.addParams("ComunidadId",this.searchForm.value.ComunidadId);

    index = this.query.params.findIndex(obj => obj.key === "UnidadFuncionalId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.UnidadFuncionalId;
    else
      this.query.addParams("UnidadFuncionalId",this.searchForm.value.UnidadFuncionalId);

    index = this.query.params.findIndex(obj => obj.key === "Usuario");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Usuario;
    else
      this.query.addParams("Usuario",this.searchForm.value.Usuario);

    index = this.query.params.findIndex(obj => obj.key === "NroDocumento");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.NroDocumento;
    else
      this.query.addParams("NroDocumento",this.searchForm.value.NroDocumento);

    index = this.query.params.findIndex(obj => obj.key === "MailContacto");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MailContacto;
    else
      this.query.addParams("MailContacto",this.searchForm.value.MailContacto);

    index = this.query.params.findIndex(obj => obj.key === "MovilContacto");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MovilContacto;
    else
      this.query.addParams("MovilContacto",this.searchForm.value.MovilContacto);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloDeudasPendientes");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerSoloDeudasPendientes;
    else
      this.query.addParams("VerSoloDeudasPendientes",this.searchForm.value.VerSoloDeudasPendientes);

    index = this.query.params.findIndex(obj => obj.key === "Signo");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Signo;
    else
      this.query.addParams("Signo",this.searchForm.value.Signo);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerSoloActivos;
    else
      this.query.addParams("VerSoloActivos", this.searchForm.value.VerSoloActivos);
  }

  onAccept() {
    this.dialogRef.close();
  }

  onExport() {
    var search = new SearchMovimientoRequest(null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,
      null, null, null, null, null, null, null, null, null, null, null, null, null, null);
    search = {
      ...search,
      ...this.searchForm.value,
      ...{
        ProveedorId: this.searchForm.get("Proveedor")?.value?.Id
      }
    };

    this.isExporting = true;
    this.movimientoService.exportSearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "DetalleMovimientosCuentasDeudoras_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onExportContactos() {
    var search = new SearchMovimientoRequest(null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,
      null, null, null, null, null, null, null, null, null, null, null, null, null, null);
    search = {
      ...search,
      ...this.searchForm.value,
      ...{
        ProveedorId: this.searchForm.get("Proveedor")?.value?.Id
      }
    };

    this.isContactosExporting = true;
    this.movimientoService.exportReporteEstadoCuentasContactos(search).subscribe((data: Blob) => {
      this.isContactosExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "DetalleMovimientosCuentasDeudorasContactos_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isContactosExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onVerSoloVencidosChange() {
    var v : Date | null = null;
    if (this.verSoloVencidos)
      v = this.input.FechaVencimientoControl;

    this.searchForm.get("FechaVencimientoHasta")?.setValue(v);
    this.onSearch();
  }

  getContactos() {
    this.isContactosSearching = true;
    this.movimientoService.getReporteEstadoCuentasContactos(this.input.SelectedRow.CuentaImputadaId).subscribe(data => {
      this.isContactosSearching = false;
      if (data != null && data.Success)
        this.contactosList = data.Result.result;
    },
    (err: HttpErrorResponse) => {
      this.isContactosSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  enviarDetalleDeuda(item: any, medio: string) {
    this.input.ReportFilter.FechaVencimientoHasta = this.input.FechaVencimientoControl;
    var r = new EnviarDetalleDeudaRequestDto(medio, item.Id, this.input?.ReportFilter);

    // this.isContactosSearching = true;
    this.movimientoService.enviarDetalleDeuda(r).subscribe(data => {
      // this.isContactosSearching = false;
      if (data != null && data.Success) {
        switch (medio) {
          case "WHATSAPP":
            if (data.Result.EnviadoOk) {
              let mensaje = encodeURIComponent(data.Result.MensajeDeuda);
              let whatsAppUrl = 'https://web.whatsapp.com/send?phone=' + item.MovilContacto + '&text=' + mensaje;

              window.open(whatsAppUrl, "_blank");
            }
            break;

          case "MAIL":
            this.sharedFunctions.showMessage("Deuda enviada éxitosamente!", "Operación Exitosa!");
            break;
        }
      }
    },
    (err: HttpErrorResponse) => {
      // this.isContactosSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }
}
